export default __webpack_public_path__ + "static/media/assign.b60b7a64.svg";